import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstCf7: [],
		cf7: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, cf7){
			state.cf7 = cf7
			if (cf7)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.cf7 = null
		},
		setParamsDataTable(state, payload){
			state.lstCf7 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async get(store, cf7transp){
			return await this._vm.$axios.get(`/Transporter/Transporter/Find/${cf7transp}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find(store, cf7transp){
			store.state.loading = true
			store.commit("initForm")
			await store.dispatch("get", cf7transp)
			.then(cf7 => {
				store.commit("set", cf7)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
			return true
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Transporter/Transporter/Insert", store.state.cf7 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/transportadores")
				store.state.cf7 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Transporter/Transporter/Update", store.state.cf7 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/transportadores")
				store.state.cf7 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Transporter/Transporter/Delete/${store.state.cf7.cf7transp}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/transportadores/")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Transporter/Transporter/FindList")
			.then(response => {
				let lstCf7 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstCf7 = lstCf7
				store.state.hasNext = lstCf7.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstCf7 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Transporter/Transporter/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstCf7 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async shippingCalculate(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Calculando frete", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Transporter/Transporter/ShippingCalculate", params )
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async findByCodext(store, cf7codext){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Consultando transportadora", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.get(`/Transporter/Transporter/FindByCodext/${cf7codext}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			
			return payload
		},
	}
}